import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontWeights,
  palette,
}: Theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    marginBottom: 0,
    paddingBottom: '0.5rem',
  },
  rootInactive: {
    paddingBottom: 0,
    marginBottom: '-0.375rem',
  },
  icon: {
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8125rem',
    fontWeight: fontWeights.medium,
    color: palette.common.white,
    flexShrink: 0,
    lineHeight: 1,
  },
  iconDeactivated: {
    backgroundColor: palette.grey[400],
  },
  labelText: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: fontWeights.medium,
  },
  name: {
    fontSize: '0.75rem',
    fontWeight: fontWeights.medium,
    color: palette.text.primary,
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
  },
  status: {
    fontSize: '0.75rem',
    color: palette.error.main,
  },
  consumerLabel: {
    display: 'inline-flex',
    gap: '0.25rem',
    alignItems: 'center',
  },
  consumerIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: palette.primary.main,
    flexShrink: 0,
  },
  iconDeleted: {
    width: '1.25rem',
    height: '1.25rem',
    color: palette.error.main,
    flexShrink: 0,
    '& path': {
      fill: palette.error.main,
    },
  },
}));
